import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import _ = require('lodash');
import { Subject } from 'rxjs';
import { RiskEvaluationService } from '../../../services/risk-evaluation.service';
import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'app-risk-department',
  templateUrl: './risk-department.component.html',
  styleUrls: ['./risk-department.component.css']
})
export class RiskDepartmentComponent implements OnInit {

  departmentForm: FormGroup;
  editdepartmentForm: FormGroup;
  departmentMasterList: any[];
  evaluationTypeList: any[];
  evaluationCriteriaList: any[];
  evaluationType: any;
  evaluationCriteria: any;
  departmentID: any;
  departmentIdToDelete: any;
  editCriteriaId: any;
  evaluationevalCriteriaList: any[];
  disableSavebutton: boolean = false;
  disableupdatebutton: boolean = false;

  @ViewChild(DataTableDirective, { static: true })
  dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  dtTrigger: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private alert: AlertComponent,
    private riskEvaluationService: RiskEvaluationService
  ) { }

  ngOnInit() {
    this.dtOptions = {
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      // scrollY: "440px",
      // scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pageLength: 10,
      search: true,
      language: {
        //made changes for datatables for next previous button
        paginate: {
          first: '<<',
          last: '>>',
          next: '>',
          previous: '<',
        },
      },
    };

    this.departmentForm = new FormGroup({
      // evaluationType: new FormControl('', [Validators.required]),
      evaluationCriteria: new FormControl('', [Validators.required]),
      RiskDepartment: new FormControl('', [Validators.required]),
    });

    this.editdepartmentForm = new FormGroup({
      // editEvaluationType: new FormControl('', [Validators.required]),
      editEvaluationCriteria: new FormControl('', [Validators.required]),
      editDepartmentText: new FormControl('', [Validators.required]),
    });

    this.getQuestionMasterList();
    this.getEntityListDetails();
    this.getEvaluationCriteriaList();
  }

  getInputValueChange(event: Event): string {
    // @ts-ignore
    return (event.target ? (event.target as HTMLInputElement) : event).value;
  }

  getQuestionMasterList() {
    this.riskEvaluationService
      .getRiskDepartmentList()
      .then((response) => {
        if (response.status == 0) {
          $('#riskDepartmentTable').DataTable().destroy();
          if (_.size(response.departmentList)) {
            this.departmentMasterList = response.departmentList;
            this.dtTrigger.next();
          } else {
            this.departmentMasterList = [];
            this.dtTrigger.next();
          }
        } else {
          this.departmentMasterList = [];
          this.dtTrigger.next();
        }
      });
  }

  getEntityListDetails() {
    // this.departmentForm.reset();

    this.riskEvaluationService.getEvaluationTypeList().then((response) => {
      if (response.status == 0) {
        if (_.size(response.evalTypeList)) {
          this.evaluationTypeList = response.evalTypeList;
        } else {
          this.evaluationTypeList = [];
        }
      } else {
        this.evaluationTypeList = [];
      }
    });
  }

  showGetEntityListDetails() {
    // this.departmentForm.reset();
    //on click of button to show popup form..
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#departmentMasterModal').removeClass('show').hide();

    setTimeout(() => {
      $('#departmentMasterModal').modal('show');
    }, 100);
    this.riskEvaluationService.getEvaluationTypeList().then((response) => {
      if (response.status == 0) {
        if (_.size(response.evalTypeList)) {
          this.evaluationTypeList = response.evalTypeList;
        } else {
          this.evaluationTypeList = [];
        }
      } else {
        this.evaluationTypeList = [];
      }
    });
  }

  getEvaluationCriteriaList() {
    this.riskEvaluationService.getEvaluationCriteriaList().then((response) => {
      if (response.status == 0) {
        //console.log("criterialist new",response)
        if (_.size(response.evalCriteriaList)) {
          this.evaluationevalCriteriaList = response.evalCriteriaList;
        } else {
          this.evaluationevalCriteriaList = [];
        }
      } else {
        this.evaluationevalCriteriaList = [];
      }
    });
  }

  // getCriteriaListByEntityId(event) {
  //
  //   this.departmentForm.controls.evaluationCriteria.setValue("");
  //   this.departmentForm.controls.evaluationCriteria.updateValueAndValidity();
  //   var evaluationTypeId = event.target.value;
  //  //console.log("this.departmentForm.controls.evaluationCriteria.",this.departmentForm.controls.evaluationType.value)

  //   //console.log("event", event.target.value)
  //   this.riskEvaluationService.getEvaluationCriteriaByEvalIdList(evaluationTypeId).then(response => {
  //     if (response.status == 0) {
  //       if (_.size(response.evalCriteriaList)) {
  //         this.evaluationCriteriaList = response.evalCriteriaList;
  //       } else {
  //         this.evaluationCriteriaList = [];
  //       }
  //     } else {
  //       this.evaluationCriteriaList = [];
  //     }
  //   });
  // }

  // getCriteriaListByEntityIdForEditForm(event) {
  //
  //   this.editdepartmentForm.controls.editEvaluationCriteria.setValue("");
  //   this.editdepartmentForm.controls.editEvaluationCriteria.updateValueAndValidity();
  //   var evaluationTypeId = event.target.value;
  //  //console.log("this.departmentForm.controls.evaluationCriteria.",this.editdepartmentForm.controls.editEvaluationCriteria.value)

  //   //console.log("event", event.target.value)
  //   this.riskEvaluationService.getEvaluationCriteriaByEvalIdList(evaluationTypeId).then(response => {
  //     if (response.status == 0) {
  //       if (_.size(response.evalCriteriaList)) {
  //         this.evaluationCriteriaList = response.evalCriteriaList;
  //       } else {
  //         this.evaluationCriteriaList = [];
  //       }
  //     } else {
  //       this.evaluationCriteriaList = [];
  //     }
  //   });
  // }

  closeForm() {
    this.ngOnInit();
  }

  submitQuestionDetails() {
    this.disableSavebutton = true;
    try {
      const self = this;

      var departmentObject = {
        EvaluationCriteriaID: this.departmentForm.controls.evaluationCriteria.value,
        RiskDepartment: this.departmentForm.controls.RiskDepartment.value.trim(),
      };

      this.riskEvaluationService.addRiskDepartment(departmentObject).then((response) => {
        this.disableSavebutton = false;

        if (response.status == 0) {
          $('#departmentMasterModal').modal('hide');
          this.alert.successWithOk1(response.message, () => {
            ////inside popup form dialog
            $('#departmentMasterModal').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');


          });
          this.messagePopUpTimeoutToogle();
          this.departmentForm.reset();
          this.getQuestionMasterList();
        } else {
          $('#departmentMasterModal').modal('hide');
          this.alert.error1(response.message, () => {
            ////inside popup form dialog
            $('#departmentMasterModal').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
          });

          this.messagePopUpTimeoutToogle();
          this.departmentForm.reset();
          this.getQuestionMasterList();
        }
      });
    } catch (error) { }
  }

  removeBackdrop() {
    // Manually remove any remaining modal backdrop
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }
  editQuestionDetails(selectedDepartmentID) {
    if (selectedDepartmentID != '') {
      //console.log("selectedDepartmentID",selectedDepartmentID)
      this.departmentID = selectedDepartmentID;
      // this.riskEvaluationService.getQuestionByQuestionID(this.departmentID).then(response => {

      // if (response.status == 0) {
      this.editdepartmentForm.controls.editDepartmentText.setValue(
        selectedDepartmentID.RiskDepartment
      );

      // this.editdepartmentForm.controls.editEvaluationType.setValue(selectedDepartmentID.EvaluationTypeID._id);
      // this.editdepartmentForm.controls.editEvaluationType.updateValueAndValidity();

      //console.log("hello edit function")
      // this.evaluationCriteriaList = response.evalCriteriaList;
      this.editCriteriaId = selectedDepartmentID.EvaluationCriteriaID._id;
      this.editdepartmentForm.controls.editEvaluationCriteria.setValue(
        selectedDepartmentID.EvaluationCriteriaID._id
      );
      this.editdepartmentForm.controls.editEvaluationCriteria.updateValueAndValidity();
      // this.riskEvaluationService.getEvaluationCriteriaByEvalIdList(selectedDepartmentID.EvaluationCriteriaID._id).then(response => {
      //   if (response.status == 0) {
      //     if (_.size(response.evalCriteriaList)) {
      //       //console.log("criteria")
      //       this.evaluationCriteriaList = response.evalCriteriaList;
      //       this.editCriteriaId = selectedDepartmentID.EvaluationCriteriaID._id;
      //       this.editdepartmentForm.controls.editEvaluationCriteria.setValue(selectedDepartmentID.EvaluationCriteriaID._id);
      //       this.editdepartmentForm.controls.editEvaluationCriteria.updateValueAndValidity();
      //     } else {
      //       this.evaluationCriteriaList = [];
      //       this.editCriteriaId = selectedDepartmentID.EvaluationCriteriaID._id;
      //       this.editdepartmentForm.controls.editEvaluationCriteria.setValue(selectedDepartmentID.EvaluationCriteriaID._id);
      //       this.editdepartmentForm.controls.editEvaluationCriteria.updateValueAndValidity();
      //     }
      //   } else {
      //     this.evaluationCriteriaList = [];
      //     this.editCriteriaId = selectedDepartmentID.EvaluationCriteriaID._id;
      //     this.editdepartmentForm.controls.editEvaluationCriteria.setValue(selectedDepartmentID.EvaluationCriteriaID._id);
      //     this.editdepartmentForm.controls.editEvaluationCriteria.updateValueAndValidity();
      //   }
      // });
      // this.editdepartmentForm.controls.RiskDepartment.disable();
      // this.editdepartmentForm.controls.editEvaluationType.disable();
      // this.editdepartmentForm.controls.editEvaluationCriteria.setValue(selectedDepartmentID.EvaluationCriteriaID);

      $('#editingQuestionModal').modal('toggle');
    } else {
      $('#alertPopUpTitle').css('color', '#f00');
      $('#alertPopUpTitle').text('Failure!');
      $('#alertMessage').text('Department Selection Failure');
      $('#alertMessage').css('color', '#f00');
      $('#messagePopUp').modal('toggle');
      this.messagePopUpTimeoutToogle();
    }
    //   });
    // } else {
    //   $('#alertPopUpTitle').css('color', '#f00');
    //   $('#alertPopUpTitle').text("Failure!");
    //   $('#alertMessage').text("Please select valid department.");
    //   $('#alertMessage').css('color', '#f00');
    //   $('#messagePopUp').modal('toggle');
    //   this.messagePopUpTimeoutToogle();
    //   this.departmentForm.reset();
    // }
  }

  udpateQuestionDetails() {
    this.disableupdatebutton = true;
    const self = this;

    var departmentObject = {
      _id: this.departmentID._id,
      // EvaluationTypeID: this.editdepartmentForm.controls.editEvaluationType.value,
      EvaluationCriteriaID:
        this.editdepartmentForm.controls.editEvaluationCriteria.value,
      RiskDepartment:
        this.editdepartmentForm.controls.editDepartmentText.value.trim(),
    };
    //console.log("departmentObject",departmentObject);

    this.riskEvaluationService
      .updateEvaluationDepartment(departmentObject)
      .then((response) => {
        this.disableupdatebutton = false;
        if (response.status == 0) {
          $('#riskDepartmentTable').DataTable().destroy();
          $('#editingQuestionModal').modal('toggle');
          $('#alertPopUpTitle').text('Success!');
          $('#alertPopUpTitle').css('color', 'black');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', 'black');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getQuestionMasterList();
          this.editdepartmentForm.reset();
        } else {
          $('#riskDepartmentTable').DataTable().destroy();
          $('#editingQuestionModal').modal('toggle');
          $('#alertPopUpTitle').text('Failure!');
          $('#alertPopUpTitle').css('color', '#f00');
          $('#alertMessage').text(response.message);
          $('#alertMessage').css('color', '#f00');
          $('#messagePopUp').modal('toggle');
          this.messagePopUpTimeoutToogle();
          this.getQuestionMasterList();
          this.editdepartmentForm.reset();
        }
      });
  }

  editRiskDepartmentChange(event) {
    if (event.target.value.trim() == '') {
      this.editdepartmentForm.controls.editDepartmentText.setValue(
        event.target.value.trim()
      );
      this.editdepartmentForm.controls.editDepartmentText.updateValueAndValidity();
    }
  }

  departmentFormRiskDepartmentChange(event) {
    if (event.target.value.trim() == '') {
      //console.log("event.target.value",event.target)
      this.departmentForm.controls.RiskDepartment.setValue(
        event.target.value.trim()
      );
      this.departmentForm.controls.RiskDepartment.updateValueAndValidity();
    }
  }

  deleteQuestionIdToPass(department) {
    this.departmentIdToDelete = department._id;
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#deleteQuestionMasterModal').removeClass('show').hide();

    setTimeout(() => {
      $('#deleteQuestionMasterModal').modal('show');
    }, 100);
  }

  deleteQuestionDetails() {
    //console.log(" this.departmentIdToDelete", this.departmentIdToDelete);
    this.riskEvaluationService.deleteDepartment(this.departmentIdToDelete)
      .then((response) => {
        // Hide the modal and remove any remaining backdrops
        $('#deleteQuestionMasterModal').modal('toggle');
        this.removeBackdrop(); // Manually remove any leftover backdrops

        // Set alert details based on response status
        const isSuccess = response.status == 0;
        const alertColor = isSuccess ? 'black' : '#f00';
        const alertTitle = isSuccess ? 'Success!' : 'Failure!';

        // $('#alertPopUpTitle').text(alertTitle).css('color', alertColor);
        // $('#alertMessage').text(response.message).css('color', alertColor);
        // ////inside popup form dialog
        // $('#deleteQuestionMasterModal').off('hidden.bs.modal');
        // $('.modal-backdrop').remove();
        // $('body').removeClass('modal-open');
        // $('#deleteQuestionMasterModal').modal('hide');
        // this.messagePopUpTimeoutToogle();

        // Refresh Dept list
        this.getQuestionMasterList();
        this.getEntityListDetails();
      });
  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == 'modal fade show') {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }

  editCriteria(event) {
    //console.log("event", event.target.value)
  }
}


